import { defineMessages } from 'react-intl';

const translations = {
  pagination: {
    currentPageLabel: {
      id: 'dataGrid.pagination.currentPageLabel',
      defaultMessage: 'page {page}',
      description: 'Data grid current page label',
    },
    previousPageLabel: {
      id: 'dataGrid.pagination.previousPageLabel',
      defaultMessage: 'Previous page',
      description: 'Data grid previous page label',
    },
    nextPageLabel: {
      id: 'dataGrid.pagination.nextPageLabel',
      defaultMessage: 'Next page',
      description: 'Data grid next page label',
    },
  },
};

export default defineMessages(translations);
